<ub-visually-hidden [visible]="visible">
  <div *ngIf="!isDismissed" [ngClass]="getClassNames()" (keydown.escape)="dismiss()"
    [attr.role]="priority === 'assertive' ? 'alert' : 'status'" [attr.aria-live]="priority">
    <p *ngIf="message" class="ub-alert__message">{{ message }}</p>
    <div class="ub-alert__message">
      <ng-content></ng-content>
    </div>
    <button *ngIf="dismissable" (click)="dismiss()" type="button" class="ub-alert__dismiss" aria-label="Close" i18n-aria-label>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ub-visually-hidden>
